import { render, staticRenderFns } from "./renew-list.vue?vue&type=template&id=703f664e&scoped=true&"
import script from "./renew-list.vue?vue&type=script&lang=js&"
export * from "./renew-list.vue?vue&type=script&lang=js&"
import style0 from "./renew-list.vue?vue&type=style&index=0&id=703f664e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f664e",
  null
  
)

export default component.exports